import React from 'react';
import ReactRouterPropTypes from 'react-router-prop-types';
import { FormattedMessage } from 'react-intl';

import { Pluggable } from '@folio/stripes/core';
import { useParams } from 'react-router-dom';

const InstanceWizardEditRoute = ({ match }) => {
  return (
    <Pluggable
      type="inventory-templates"
      basePath={match.path}
      redirectTo="edit"
    >
      <FormattedMessage id="ui-inventory.templatesPluginNotAvailable" defaultMessage="Templates plugin not available" />
    </Pluggable>
  );
};

InstanceWizardEditRoute.propTypes = {
  match: ReactRouterPropTypes.match.isRequired,
};

export default InstanceWizardEditRoute;
